import { getBladeExtension } from "../helpers/interface-helpers";
import { WalletConnectStrategy } from "../strategies/wallet-connect.strategy";
export class ExtensionStrategy extends WalletConnectStrategy {
    async wakeExtension() {
        const extensionInterface = await getBladeExtension();
        if (extensionInterface && typeof extensionInterface.wake === "function") {
            return await extensionInterface.wake();
        }
        return true;
    }
    async createSession(params) {
        const extension = await getBladeExtension();
        if (extension) {
            this.signers = await this.walletConnectService.initWithExtension(params === null || params === void 0 ? void 0 : params.network);
            return this.signers.map(s => s.getAccountId().toString());
        }
        return [];
    }
}
